import { ADD_TRANSACTION_PAYMENT_METHOD_NAME, METHOD_PAYTO } from 'constants';
import {
  FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME,
  FORM_ADD_PAYTO_BANK_NAME_NAME,
  FORM_ADD_PAYTO_BSB_NAME,
  FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME,
  FORM_ADD_PAYTO_PAYID_TYPE_NAME,
  PAYTO_LOG_TAG,
} from 'features/to/const';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import { isEmpty } from 'lodash';

const usePayment = () => {
  const {
    paymentMethod,
    paytoAccountsAgreement,
    paytoAccountInformation,
    isPaytoBlocked,
  } = useFormAddTransactionStore();

  const paymentMethodName =
    paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME];

  const preventByClassNames = [];
  const preventByPaymentMethods = [
    ...(isEmpty(paytoAccountsAgreement) ? [METHOD_PAYTO] : []),
  ];
  const preventPaymentMethodSelection = (e, method) => {
    let isPrevent = false;

    if (preventByPaymentMethods.includes(method)) {
      isPrevent = true;
      return isPrevent;
    }

    for (let i = 0; i < preventByClassNames.length; i++) {
      if (e?.target?.className?.includes(preventByClassNames[i])) {
        isPrevent = true;
        return isPrevent;
      }
    }

    return isPrevent;
  };

  const allowReviewAndPay = () => {
    if (paymentMethodName === METHOD_PAYTO) {
      if (isEmpty(paytoAccountInformation)) return false;

      if (isPaytoBlocked) return false;

      const newPaytoAccountInformation = { ...paytoAccountInformation };
      const isAgreementByBSB =
        !newPaytoAccountInformation?.[FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME];
      if (isAgreementByBSB) {
        delete newPaytoAccountInformation?.[
          FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME
        ];
        delete newPaytoAccountInformation?.[FORM_ADD_PAYTO_PAYID_TYPE_NAME];
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 allowReviewAndPay ➡️ isAgreementByBSB ➡️ newPaytoAccountInformation ↩`,
          newPaytoAccountInformation
        );
      } else {
        delete newPaytoAccountInformation?.[FORM_ADD_PAYTO_BSB_NAME];
        delete newPaytoAccountInformation?.[FORM_ADD_PAYTO_BANK_NAME_NAME];
        delete newPaytoAccountInformation?.[FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME];
        delete newPaytoAccountInformation?.bankCode;
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 allowReviewAndPay ➡️ isAgreementByPayId ➡️ newPaytoAccountInformation ↩`,
          newPaytoAccountInformation
        );
      }
      delete newPaytoAccountInformation?.amendPayToLimit;
      return Object.values(newPaytoAccountInformation).every((value) => value);
    }
    return true;
  };

  return {
    paymentMethodName,
    preventPaymentMethodSelection,
    allowReviewAndPay,
  };
};

export default usePayment;
